import { TextField } from "@mui/material";
import { useId } from "react";

export const OssLabeledField = ({ label, id, InputLabelProps, inputProps, SelectProps, ...props }) => {
  const generatedId = useId();
  const fieldId = id || generatedId;
  const labelId = fieldId + "-label";
  return (
    <div className="oss-labeled-field">
      <label id={labelId} htmlFor={fieldId}>{label}</label>
      <TextField {...props} id={fieldId}
        inputProps={{ ...inputProps, "aria-labelledby": labelId }}
        SelectProps={{ ...SelectProps, labelId }} />
    </div>
  );
};
